import api from "@/lib/api";

export async function checkSolicitacao(id) {
  try {
    await api.get("/secretaria-digital/solicitacao/check", { params: { id } })
    return
  } catch (error) {
    console.log('checkSolicitacao-error', error)
    return
  }
}